import React from 'react'

import { FormGroupProps } from '@/components/form/FormGroup'
import { cn } from '@/lib/utils'
import FormGroup from '@/pages/referClient/steps/1_ClientDetails/components/FormGroup'

const SmallFormGroup: React.FC<FormGroupProps> = ({ className, ...props }) => {
  return <FormGroup className={cn('grow', className)} {...props} />
}

export default SmallFormGroup
